
import { baseUrl } from "../../constants";

export default {
    "formTitle": "Add Ship Class",
    "tableTitle": "Ship Class List",
    "apiDetails": {
        startUp: () => {
        },
        list: {
            url: `${baseUrl}/api/ship/shipclass/list`,
            payload: {
                "search": "",
                "offset": 0,
                "limit": 50,
                "sort": "DESC"
            }
        },
        add: `${baseUrl}/api/ship/shipclass`,
        edit: `${baseUrl}/api/ship/shipclass/edit`,
        delete: `${baseUrl}/api/ship/shipclass/remove`
    },
    "tableCol": [
        {
            name: 'Classification Society',
            selector: row => row.shipClass,
            sortable: true
        },
        {
            name: 'Description',
            selector: row => row.description,
            sortable: true
        }
    ],
    "formData": [
        {
            "formType": "flex",
            "formFields": [
                {
                    type: 'text',
                    label: 'Classification Society',
                    name: 'shipClass',
                    required: true
                }
            ]
        },
        {
            formType: 'flex',
            formFields: [
                {
                    type: 'textArea',
                    label: 'Description',
                    name: 'description'
                }
            ]
        }
    ],
    "mockData": [{
        "shipClass": "sfs",
        "description": "dgdg"
    }]
}